<div *ngIf="iframeUrl" style="height: 90vh;">
    <iframe [src]="iframeUrl" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>
</div>